import {
  SaveServiceTitanCredentialRequest,
  SaveServiceTitanCredentialResponse,
} from "./types";
import axiosInstance from "../axiosInstance";

export const saveServiceTitanCredential = async (
  companyUuid: string,
  request: SaveServiceTitanCredentialRequest,
): Promise<SaveServiceTitanCredentialResponse> => {
  const response = await axiosInstance.post<SaveServiceTitanCredentialResponse>(
    `/api/private/companies/${companyUuid}/service-titan/credentials`,
    request,
  );
  return response.data;
};
